import digitalPrinting from "./templates/digital-printing";

export default [
  {
    id: `material`,
    title: `Описание`,
    content: {
      description: `
        <p>Обложка для паспорта сшита из плотной непромокаемой ткани на синтетической основе, по краю обложки прострочены толстой и прочной нитью. Нитки, которыми выполнена декоративная строчка по краю так же подвергаются  окрашиваются в соответствии с изображением.  Размер обложки 193 x 135 мм. Обложка подходит для всех видов паспортов. Рисунок яркий, долговечный и глянцевый.</p>
      `
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${digitalPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
